/* 
* <license header>
*/

import React from 'react'
import {Provider, defaultTheme, Grid, View} from '@adobe/react-spectrum'
import ErrorBoundary from 'react-error-boundary'
import {HashRouter as Router, Routes, Route} from 'react-router-dom'
import {AuthProvider} from '../context/AuthContext'
import {QueryClientProvider} from 'react-query';
import {queryClient} from '../utils/queryClient';
import {Home} from './Home'

function App(props) {

    // console.log('ims on App js', props.ims)
    // console.log('emnail on App js', props.email)

    // console.log('Quite Id on App JS' , props.quoteId)

    return (
        <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
            <Router>
                <Provider theme={defaultTheme} colorScheme={'light'}>
                    <QueryClientProvider client={queryClient}>
                        <AuthProvider accessToken={props.accessToken} ims={props.ims} email={props.email}>
                            <View width='100%' minHeight='100vh'>
                                <Routes>
                                    <Route path='/' element={<Home runtime={props.runtime} ims={props.ims} quoteId={props.quoteId} quoteSkus={props.quoteSkus}/>} />
                                </Routes>
                            </View>
                        </AuthProvider>
                    </QueryClientProvider>
                </Provider>
            </Router>
        </ErrorBoundary>
    )

    // Methods

    // error handler on UI rendering failure
    function onError(e, componentStack) {
    }

    // component to show if UI fails rendering
    function fallbackComponent({componentStack, error}) {
        return (
            <React.Fragment>
                <h1 style={{textAlign: 'center', marginTop: '20px'}}>
                    Something went wrong :(
                </h1>
                <pre>{componentStack + '\n' + error.message}</pre>
            </React.Fragment>
        )
    }
}

export default App
